export const iconFontAwesomeLogisticsAnchorCircleCheck = (
	<i className="fa-solid fa-anchor-circle-check"></i>
);
